<div class="card-header d-flex ps-0" id="headingOne" data-bs-toggle="collapse" href="#collapseOne">
    <a class="card-link flex-fill">Shipped Items</a>
    <i class="fas fa-chevron-up"></i>
</div>

<div id="collapseOne" class="collapse show">
    <div class="card-body">
        @if (gridConfig) {
        <div [style.height.px]="gridHeight">
            <inavista-grid #shipmentOrderReceiptsGrid class="so-popup-grid"
                [config]="gridConfig"
                (hyperlinkClick)="showMasterItemCodePopup(receiptFor($event.row))"
                (rowEditStart)="onRowEditStart($event)"
                (rowCommit)="onRowCommit($event)"
                (rowRevert)="onRowRevert()"
                (exportRequested)="onExportRequested()" />
        </div>
        }
    </div>
</div>

<!-- Serviceable Received Qty: its editor (CellEditorHost, @inavista/components), drawn in the open row's cell. -->
<ng-template #qtyEditor let-row>
    <app-cell-editor [edit]="qtyEdit" field="quantityServiceable" [rowData]="receiptFor(row)" [registry]="openEditors" />
</ng-template>
